export const TIER_LEVELS = {
  free: 0,
  basic: 1,
  standard: 2,
  professional: 3,
  advanced: 4,
  enterprise: 5
}

export function getTierLevel(tier: string): number {
  return TIER_LEVELS[tier as keyof typeof TIER_LEVELS] || 0;
}

export function hasAccess(userTier: string, requiredTier: string): boolean {
  return (getTierLevel(userTier) >= getTierLevel(requiredTier));
}

export function getNextTier(currentTier: string): string {
  const currentLevel = getTierLevel(currentTier);
  const nextLevel = currentLevel + 1;
  
  const tierEntries = Object.entries(TIER_LEVELS);
  const nextTierEntry = tierEntries.find(([_, level]) => level === nextLevel);
  
  return nextTierEntry ? nextTierEntry[0] : currentTier;
}

export function formatTierName(tier: string): string {
  return tier.charAt(0).toUpperCase() + tier.slice(1);
} 